import {
  SET_GROUP_AVAILABLE_SERVICES,
  SET_GROUP_SELECTED_SERVICES,
  SET_ORDER_DETAILS,
  SET_GROUP_DATA,
} from '../ActionsTypes';

const setGroupAvailableServicesAction = (data) => ({
  type: SET_GROUP_AVAILABLE_SERVICES,
  payload: data,
});
const setGroupSelectedServicesAction = (data) => ({
  type: SET_GROUP_SELECTED_SERVICES,
  payload: data,
});
const setGroupOrderDetailsAction = (data) => ({
  type: SET_ORDER_DETAILS,
  payload: data,
});
const setGroupDataAction = (data) => ({
  type: SET_GROUP_DATA,
  payload: data,
});

export {
  setGroupAvailableServicesAction,
  setGroupSelectedServicesAction,
  setGroupOrderDetailsAction,
  setGroupDataAction,
};
